function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M387 238V131C387 59 328 0 256 0S125 59 125 131v107H92c-18 0-33 15-33 33v188c0 19 15 33 33 33h328c18 0 33-14 33-33V271c0-18-15-33-33-33zm-197 0V131c0-36 30-65 66-65s66 29 66 65v107z"
})));